import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-50eec695"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "record-module"
};
import RecordBar from './coms/recordBar.vue';
import RecordVideo from './coms/recordVideo.vue';
import GuideMask from './coms/guideMask.vue';
export default /*#__PURE__*/_defineComponent({
  setup: function (__props) {
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(RecordBar), _createVNode(RecordVideo), _createVNode(GuideMask)]);
    };
  }
});